import { ResponseData } from './types';
import { PACKAGE_VERSION } from '../types';

export const createAbortableRequestPromise = (method: string, url: string, body?: string): Promise<ResponseData> => {
  const xhr = new XMLHttpRequest();
  const promise = new Promise<ResponseData>((resolve, reject) => {
    xhr.open(method, url, true);
    xhr.setRequestHeader('Client-Version', PACKAGE_VERSION);
    if (body) {
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    }

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (Math.floor(xhr.status / 100) === 2) {
          const successData = xhr.responseText ? JSON.parse(xhr.responseText) : null;
          return resolve({ status: xhr.status, response: successData });
        }
        if (xhr.status === 0) {
          return reject({ status: xhr.status, response: 'Aborted' });
        }
        return reject({ status: xhr.status, response: xhr.responseText });
      }
    };
    xhr.send(body);
  });

  promise.abort = () => xhr.abort();

  return promise;
};

export function transformArguments(args: any): { [key: string]: string } {
  if (!args) return {};
  const out: { [key: string]: string } = {};
  const append = ['market', 'sessionKey', 'customerKey'];

  for (const prop of Object.getOwnPropertyNames(args)) {
    append.some((da: string) => da === prop) ? out[`esales.${prop}`] = args[prop] : out[prop] = args[prop];
  }
  return out;
}

export function stringify(args: any): string {
  if (!args) return '';
  return Object.getOwnPropertyNames(args).map(arg => `${arg}=${encodeURIComponent(args[arg])}`).join('&');
}
